import React, { Component } from 'react'
import * as styles from './index.module.css'
export default class TwoColumnText extends Component {
  render() {
    var props = this.props

    return (
      <div className={styles.lightContainer}>
        <div className="wrapper">
          <div className={styles.container}>
            <h2>{props.title}</h2>
            <span className="paragraph">{props.subtitle.subtitle}</span>
          </div>
        </div>
      </div>
    )
  }
}
